export const COLOR_GREEN = '#00b300';
export const COLOR_YELLOW = '#ffcc00';
export const COLOR_RED = '#ff0000';
export const COLOR_WHITE = '#ffffff';
export const COLOR_BLACK = '#000000';
